import { FC, useState, useRef, useEffect, useMemo } from 'react'
import DOMPurify from 'dompurify'
import Scrollspy from 'utils/scrollspy/scrollspy'
import clsx from 'clsx'

import ScrollArea from 'containers/scroll-area/scroll-area'
import usePCWindow from 'hooks/usePCWindow'
import useNavbarHeight from 'store/navbar/useNavbarHeight'
import BtnOpenContents from './btn-open-contents/btn-open-contents'

import { ITableOfContents } from '../../articles/article-clinic/article-clinic.type'
import { ScreenSize } from 'constants/media-constanst'
import { Events } from 'constants/events'

import styles from './table-of-contents.module.scss'

// TODO почистить лишнее (переписать)
const TableOfContents: FC<ITableOfContents> = ({
  tableOfContents,
  articleContentRef,
  modificator,
}: ITableOfContents) => {
  const isPC = usePCWindow(ScreenSize.big)
  const { navbarHeight } = useNavbarHeight()
  const contentListRef = useRef<HTMLDivElement>(null)

  const [isContentListOpen, setContentListOpen] = useState(false)
  const [isPositionFixed, setPositionFixed] = useState(false)
  const [isHideContentList, setHideContentList] = useState(false)

  const toggleTableOfContent = () => !isPC && setContentListOpen((prevState) => !prevState)

  const arrOfIds = useMemo(() => tableOfContents.map((el) => el.id), [tableOfContents])

  const isNMO = modificator === 'nmo'

  useEffect(() => {
    const articleContentNode = articleContentRef.current
    const contentListNode = contentListRef.current
    const handleTableOfContents = () => {
      const { scrollY } = window
      if (scrollY > 200) setPositionFixed(true)
      else setPositionFixed(false)

      if (articleContentNode && contentListNode) {
        const diff =
          articleContentNode.getBoundingClientRect().bottom -
          contentListNode.getBoundingClientRect().bottom
        if (diff < 50) setHideContentList(true)
        else setHideContentList(false)
      }
    }

    window.addEventListener(Events.SCROLL, handleTableOfContents)
    return () => window.removeEventListener(Events.SCROLL, handleTableOfContents)
  }, [isPositionFixed])

  return (
    <>
      {!isPC && <BtnOpenContents open={toggleTableOfContent} isOpened={isContentListOpen} />}
      <div
        className={clsx(styles.contentList, {
          [styles.contentListIsOpen]: isContentListOpen,
        })}
        style={{ top: navbarHeight + (isPC ? 20 : 0) }}
      >
        <div className={clsx(styles.whiteBG)} ref={contentListRef} onClick={toggleTableOfContent}>
          <div className={styles.contentListHeader}>
            <h4 className={styles.contentHeader}>Содержание</h4>
          </div>
          <div
            className={clsx(styles.ScrollAreaWrapper, {
              [styles.ScrollAreaWrapperNMO]: isNMO,
            })}
          >
            <ScrollArea>
              <div className={clsx(styles.contentListItemWrapper)}>
                <Scrollspy items={arrOfIds} currentClassName={!isNMO ? 'is-current' : ''}>
                  {tableOfContents.map(({ name, id }) => (
                    <p key={id} className={styles.contentListItem}>
                      <a
                        href={`#${id}`}
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(name),
                        }}
                      ></a>
                    </p>
                  ))}
                </Scrollspy>
              </div>
            </ScrollArea>
          </div>
        </div>
      </div>
    </>
  )
}

export default TableOfContents
